import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  getYear,
} from "date-fns";

import Drawer from "..";
import Typography from "../../Typography";
import DatePicker from "../../DatePicker";
import FieldContainer from "../../FieldContainer/FieldContainer";
import Button from "../../Button/Button";
import SelectTag from "../../SelectTag/SelectTag";

import { setFilterNps } from "../../../actions/npsFilters";

import * as APINps from "../../../services/nps/functions";

import { ReactComponent as CleanIcon } from "../../../build/images/icons/Clean.svg";

import "./nps-filters.css";

export default function NpsFilters({
  screen,
  dataAdditionalFields = [],
  ...others
}) {
  const npsFilters = useSelector((state) => state.npsfilters);

  const dispatch = useDispatch();
  const finalDateDefault = new Date();
  const initialDateDefault = new Date(
    new Date().setDate(new Date().getDate() - 30)
  );

  const [initialDate, setInitialDate] = useState(
    new Date(npsFilters.datestart)
  );
  const [finalDate, setFinalDate] = useState(new Date(npsFilters.dateend));
  const [controlActive, setControlActive] = useState(false);
  const [businessList, setBusinessList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [businessSelected, setBusinessSelected] = useState(npsFilters.business);
  const [periodSelected, setPeriodSelected] = useState(npsFilters.period);
  const [comparisonSelected, setComparisonSelected] = useState(
    npsFilters.comparison
  );
  const [unitsSelected, setUnitsSelected] = useState(npsFilters.units);
  const listRequest = [
    { id: 1, label: "Dia" },
    { id: 2, label: "Semana" },
    { id: 3, label: "Mês" },
    { id: 4, label: "Ano" },
    { id: 5, label: "Personalizar" },
  ];

  const listComparison = [
    { id: "PROMOTOR", label: "Promotor" },
    { id: "NEUTRO", label: "Neutro" },
    { id: "DETRATOR", label: "Detrator" },
  ];

  async function getBusinessList() {
    const response = await APINps.getBusiness();

    if (response.status === 200) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setBusinessList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  async function getUnitsList() {
    const response = await APINps.getUnits();

    if (response.status === 200) {
      let dataUpdated = [];

      response.data.forEach((datum) => {
        let requestItem = {};

        requestItem.id = datum.id;
        requestItem.label = datum.description;

        dataUpdated.push(requestItem);
      });
      setUnitsList(dataUpdated);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  const removeOptionBusiness = (idRemoved) => {
    let elements = arrayRemove(businessSelected, idRemoved);
    setBusinessSelected(elements);
  };

  const removeOptionPeriod = (idRemoved) => {
    let elements = arrayRemove(periodSelected, idRemoved);
    setPeriodSelected(elements);
  };

  const removeOptionComparison = (idRemoved) => {
    let elements = arrayRemove(comparisonSelected, idRemoved);
    setComparisonSelected(elements);
  };

  const removeOptionUnits = (idRemoved) => {
    let elements = arrayRemove(unitsSelected, idRemoved);
    setUnitsSelected(elements);
  };

  const changeOptionsBusiness = (option) => {
    const arrayFound = businessSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionBusiness(arrayFound.id);
    } else {
      setBusinessSelected([
        ...businessSelected,
        { id: option.id, name: option.label },
      ]);
    }
  };

  const changeOptionsPeriod = (option) => {
    setPeriodSelected([{ id: option.id, label: option.label }]);
  };

  const changeOptionsComparison = (option) => {
    const arrayFound = comparisonSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionComparison(arrayFound.id);
    } else {
      setComparisonSelected([{ id: option.id, name: option.label }]);
    }
  };

  const changeOptionsUnits = (option) => {
    const arrayFound = unitsSelected.find(
      (element) => element.id === option.id
    );
    if (arrayFound) {
      removeOptionUnits(arrayFound.id);
    } else {
      setUnitsSelected([
        ...unitsSelected,
        { id: option.id, label: option.label },
      ]);
    }
  };

  const arrayRemove = (arr, value) => {
    return arr.filter(function (elem) {
      return elem.id != value;
    });
  };

  function changeDateInput(idType) {
    if (idType === 1) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            selected={finalDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  0,
                  0,
                  0,
                  0
                )
              );
              setFinalDate(
                new Date(
                  newDate.getFullYear(),
                  newDate.getMonth(),
                  newDate.getDate(),
                  23,
                  59,
                  59,
                  999
                )
              );
            }}
            selectRangeType="start"
            // endDate={finalDate}
            // maxDate={finalDate}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 2) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfWeek(newDate));
              setFinalDate(endOfWeek(newDate));
            }}
            selectRangeType="start"
            showWeekPicker={true}
            dateFormat={"dd/MM/yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 3) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfMonth(newDate));
              setFinalDate(endOfMonth(newDate));
            }}
            selectRangeType="start"
            showMonthYearPicker={true}
            dateFormat={"MMMM 'de' yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 4) {
      return (
        <FieldContainer
          title="Selecione o período"
          className="case-client"
          htmlFor=""
        >
          <DatePicker.DateRange
            selected={initialDate}
            setDate={(event) => {
              const newDate = event;

              setInitialDate(startOfYear(newDate));
              setFinalDate(endOfYear(newDate));
            }}
            selectRangeType="start"
            showYearPicker={true}
            dateFormat={"yyyy"}
          />
        </FieldContainer>
      );
    } else if (idType === 5) {
      const finalDateCopy = new Date(finalDate);
      const initialDateCopy = new Date(initialDate);
      return (
        <>
          <FieldContainer
            title="Data início"
            className="case-client"
            htmlFor=""
          >
            <DatePicker.DateRange
              selected={initialDate}
              setDate={(event) => {
                const newDate = event;
                setInitialDate(newDate);
              }}
              selectRangeType="start"
              endDate={finalDate}
              maxDate={
                screen === "Comparisons"
                  ? finalDateCopy.setFullYear(finalDateCopy.getFullYear() - 1)
                  : finalDate
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>

          <FieldContainer title="Data fim" className="case-client" htmlFor="">
            <DatePicker.DateRange
              selected={finalDate}
              setDate={(event) => {
                const newDate = event;
                setFinalDate(newDate);
              }}
              selectRangeType="end"
              startDate={initialDate}
              minDate={
                screen === "Comparisons"
                  ? initialDateCopy.setFullYear(
                      initialDateCopy.getFullYear() + 1
                    )
                  : initialDate
              }
              dateFormat={screen === "Comparisons" ? "yyyy" : "dd/MM/yyyy"}
              ref={others.refFinalDate}
              isClearable={false}
              showYearPicker={screen === "Comparisons" ? true : false}
            />
          </FieldContainer>
        </>
      );
    }
  }

  const getCasesFilterAdvanceds = () => {
    dispatch(setFilterNps("active", true));
    dispatch(setFilterNps("business", businessSelected));
    dispatch(setFilterNps("period", periodSelected));
    dispatch(setFilterNps("comparison", comparisonSelected));
    dispatch(setFilterNps("units", unitsSelected));

    if (screen === "Comparisons") {
      dispatch(setFilterNps("datestartComparisons", initialDate));
      dispatch(setFilterNps("dateendComparisons", finalDate));
    } else {
      dispatch(setFilterNps("datestart", initialDate));
      dispatch(setFilterNps("dateend", finalDate));
    }

    others.onClose(false);
  };

  const cleanFiltersAdvanceds = () => {
    dispatch(setFilterNps("active", false));
    dispatch(setFilterNps("business", []));
    dispatch(setFilterNps("period", [{ id: 5, label: "Personalizar" }]));
    dispatch(
      setFilterNps("comparison", [{ id: "PROMOTOR", label: "Promotor" }])
    );
    dispatch(setFilterNps("units", []));
    dispatch(setFilterNps("datestart", initialDateDefault));
    dispatch(setFilterNps("dateend", finalDateDefault));

    others.onClose(false);
  };

  const cleanFilters = () => {
    cleanFiltersAdvanceds();
    setBusinessSelected([]);
    setPeriodSelected([{ id: 5, label: "Personalizar" }]);
    setComparisonSelected([{ id: "PROMOTOR", label: "Promotor" }]);
    setUnitsSelected([]);
    setInitialDate(initialDateDefault);
    setFinalDate(finalDateDefault);
  };

  useEffect(() => {
    getBusinessList();
    getUnitsList();
  }, []);

  useEffect(() => {
    switch (periodSelected[0].id) {
      case 1:
        setInitialDate(
          new Date(
            finalDate.getFullYear(),
            finalDate.getMonth(),
            finalDate.getDate(),
            0,
            1,
            0,
            0
          )
        );
        setFinalDate(
          new Date(
            finalDate.getFullYear(),
            finalDate.getMonth(),
            finalDate.getDate(),
            23,
            59,
            59,
            999
          )
        );
        break;
      case 2:
        setInitialDate(startOfWeek(finalDate));
        setFinalDate(endOfWeek(finalDate));
        break;
      case 3:
        setInitialDate(startOfMonth(finalDate));
        setFinalDate(endOfMonth(finalDate));
        break;
      case 4:
        setInitialDate(startOfYear(finalDate));
        setFinalDate(endOfYear(finalDate));
        break;
      case 5:
        const updateInitialDateDefault = npsFilters.datestart
          ? new Date(npsFilters.datestart)
          : initialDateDefault;
        const updateFinalDateDefault = npsFilters.dateend
          ? new Date(npsFilters.dateend)
          : finalDateDefault;

        const updateInitialDateComparisons = npsFilters.datestartComparisons
          ? new Date(npsFilters.datestartComparisons)
          : initialDateDefault;

        const updateFinalDateComparisons = npsFilters.dateendComparisons
          ? new Date(npsFilters.dateendComparisons)
          : finalDateDefault;

        const initialYear = getYear(updateInitialDateComparisons);
        const finalYear = getYear(updateFinalDateComparisons);

        if (screen === "Comparisons") {
          if (initialYear === finalYear) {
            const initialDateOneYearAgo = new Date(
              updateInitialDateComparisons
            );
            initialDateOneYearAgo.setFullYear(
              updateInitialDateComparisons.getFullYear() - 1
            );
            setInitialDate(initialDateOneYearAgo);
            setFinalDate(updateFinalDateComparisons);
          } else {
            setInitialDate(updateInitialDateComparisons);
            setFinalDate(updateFinalDateComparisons);
          }
        } else {
          setInitialDate(updateInitialDateDefault);
          setFinalDate(updateFinalDateDefault);
        }
        /*
        if (screen === "Comparisons" || screen === "Rankings") {
          setInitialDate(new Date(npsFilters.datestart));
          setFinalDate(new Date(npsFilters.dateend));
        } else {
          setInitialDate(initialDateDefault);
          setFinalDate(finalDateDefault);
        }
        */
        break;

      default:
        break;
    }
  }, [periodSelected, screen]);

  useEffect(() => {
    if (
      businessSelected.length === 0 &&
      comparisonSelected.length === 0 &&
      unitsSelected.length === 0
      // &&
      // initialDate.getDate() === initialDateDefault.getDate() &&
      // finalDate.getDate() === finalDateDefault.getDate()
    ) {
      setControlActive(false);
    } else {
      setControlActive(true);
    }
  }, [
    businessSelected.length,
    periodSelected.length,
    comparisonSelected.length,
    unitsSelected.length,
    initialDate,
    finalDate,
  ]);

  useEffect(() => {
    window.localStorage.setItem("npsFilters", JSON.stringify(npsFilters));
  }, [npsFilters]);

  useEffect(() => {
    if (screen !== "Dashboard") {
      changeOptionsPeriod({ id: 5, label: "Personalizar" });
    }
  }, [screen]);

  return (
    <Drawer.Main
      title="Filtros"
      isOpen={others.isOpen}
      onClose={() => others.onClose(false)}
      className="dashboard-height"
    >
      <div className={`filters-dashboard-container`}>
        <div className="filters-dashboard">
          <FieldContainer title="Negócio" htmlFor="">
            <div className="filters-dashboard-container-tag">
              <SelectTag
                valueTag={businessSelected}
                options={businessList}
                onSelect={(option) => {
                  changeOptionsBusiness(option);
                }}
                isCloseOnSelect={false}
              />
            </div>
          </FieldContainer>
          {screen === "Dashboard" && (
            <FieldContainer title="Selecione o período" htmlFor="">
              <div className="filters-dashboard-container-tag">
                <SelectTag
                  valueTag={periodSelected}
                  options={listRequest}
                  onSelect={(option) => {
                    changeOptionsPeriod(option);
                  }}
                  multiple={false}
                />
              </div>
            </FieldContainer>
          )}
          <div className="filters-dashboard-container__date-range-container">
            {changeDateInput(periodSelected[0].id)}
          </div>
          <FieldContainer title="Unidades" htmlFor="">
            <div className="filters-dashboard-container-tag">
              <SelectTag
                valueTag={unitsSelected}
                options={unitsList}
                onSelect={(option) => {
                  changeOptionsUnits(option);
                }}
                isCloseOnSelect={false}
              />
            </div>
          </FieldContainer>
          {screen === "Comparisons" && (
            <FieldContainer title="Perfil" htmlFor="">
              <div className="filters-dashboard-container-tag">
                <SelectTag
                  valueTag={comparisonSelected}
                  options={listComparison}
                  onSelect={(option) => {
                    changeOptionsComparison(option);
                  }}
                  multiple={false}
                />
              </div>
            </FieldContainer>
          )}
        </div>
        <div className="filters-dashboard__buttons">
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              cursor: `${!controlActive ? "default" : "pointer"}`,
            }}
            onClick={controlActive ? cleanFilters : null}
          >
            <CleanIcon
              className={`${!controlActive ? "disabled-icon" : "clean-icon"}`}
            />
            <div>
              <Typography.H5
                weight="400"
                color={`${!controlActive ? "gray-125" : "red-2"}`}
              >
                Limpar Filtros
              </Typography.H5>
            </div>
          </div>
          <Button
            className={"buttons-aplyfilters"}
            onClick={getCasesFilterAdvanceds}
          >
            Aplicar Filtros
          </Button>
        </div>
      </div>
    </Drawer.Main>
  );
}
